import { IReduxState } from "#webapp/src/state/reducers/root.reducer";
import { useSelector } from "react-redux";

export function useFeatureGrid() {
  return useSelector((state: IReduxState) => state.featureGrid);
}
